import React, { useState } from "react";

type Route = "home" | "product" | "builders" | "pricing";

interface LandingNavProps {
  active?: Route;
}

const LINKS: { id: Route; href: string; label: string }[] = [
  { id: "home", href: "/", label: "Home" },
  { id: "product", href: "/product", label: "Products" },
  { id: "builders", href: "/builders", label: "Builders" },
  { id: "pricing", href: "/pricing", label: "Pricing" },
];

const goToLogin = () => {
  window.location.href = "/login";
};

const LandingNav: React.FC<LandingNavProps> = ({ active }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const linkClass = (isActive: boolean) =>
    isActive
      ? "text-white text-sm font-medium underline underline-offset-4 decoration-2"
      : "text-white/80 hover:text-white text-sm font-medium transition-colors";

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/60 backdrop-blur-sm">
      <div className="max-w-[1200px] mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-8">
          <a href="/" aria-label="OpenSky home">
            <img
              src="/images/logo.svg"
              alt="OpenSky"
              className="h-10 w-auto cursor-pointer"
            />
          </a>

          {/* Desktop links */}
          <div className="hidden md:flex items-center gap-6">
            {LINKS.map((link) => (
              <a
                key={link.id}
                href={link.href}
                className={linkClass(active === link.id)}
                aria-current={active === link.id ? "page" : undefined}
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>

        <div className="flex items-center gap-3">
          {/* Desktop login */}
          <button
            onClick={goToLogin}
            className="hidden md:inline-block px-6 py-2 rounded-[6px] border border-white text-white text-sm font-medium hover:bg-white hover:text-black transition-colors"
          >
            Login
          </button>

          {/* Mobile hamburger */}
          <button
            type="button"
            aria-label={mobileOpen ? "Close menu" : "Open menu"}
            aria-expanded={mobileOpen}
            onClick={() => setMobileOpen((v) => !v)}
            className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-[6px] border border-white/30 text-white hover:bg-white/10 transition-colors"
          >
            {mobileOpen ? (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            ) : (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Mobile menu panel */}
      {mobileOpen && (
        <div className="md:hidden bg-black/90 backdrop-blur-sm border-t border-white/10">
          <div className="max-w-[1200px] mx-auto px-6 py-4 flex flex-col gap-4">
            {LINKS.map((link) => (
              <a
                key={link.id}
                href={link.href}
                className={linkClass(active === link.id) + " py-2"}
                aria-current={active === link.id ? "page" : undefined}
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <button
              onClick={goToLogin}
              className="mt-2 w-full px-6 py-2 rounded-[6px] border border-white text-white text-sm font-medium hover:bg-white hover:text-black transition-colors"
            >
              Login
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default LandingNav;
